import React, { Fragment } from 'react';
import './App.css';
import LanguageContextProvider from './context/LanguageContext'
import BmiContextProvider from './context/BmiContext'
import TypeContextProvider from './context/TypeContext'
// import Main from './components/calculate'
import Navbar from './components/calculate/Navbar';
// import {
//   BrowserRouter as Router,
//   Switch,
//   Route,
//   Link
// } from "react-router-dom";

function App() {
  return (
    <Fragment>
      <LanguageContextProvider>
        <TypeContextProvider>
          <BmiContextProvider>
            <Navbar />
          </BmiContextProvider>
        </TypeContextProvider>
      </LanguageContextProvider>
    </Fragment>
  );
}

export default App;
